module.exports = __webpack_public_path__ + "img/alteration.26eede6d.png";